import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, type Agent, type Skill } from "../lib/api";

export default function AgentDetail() {
  const { name } = useParams<{ name: string }>();
  const [agent, setAgent] = useState<Agent | null>(null);
  const [ownedSkills, setOwnedSkills] = useState<Skill[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!name) return;
    Promise.all([
      api<Agent>(`/governance/agents/${name}`),
      api<{ skills: Skill[] }>(`/governance/skills?owner=${name}`),
    ]).then(([a, s]) => {
      setAgent(a); setOwnedSkills(s.skills); setLoading(false);
    });
  }, [name]);

  if (loading) return <div className="text-center py-8 text-gray-500">Loading {name}…</div>;
  if (!agent) return null;

  return (
    <div className="space-y-6">
      <Link to="/governance" className="text-sm text-growtify-500 hover:underline">← Back to Governance</Link>
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">{agent.name}</h1>
        <p className="text-xs text-gray-500 mt-1">
          Rank {agent.authority_rank} · model: {agent.model_default} · scope: {agent.scope_set}
        </p>
      </div>

      {ownedSkills.length > 0 && (
        <div>
          <h2 className="text-sm font-medium uppercase tracking-wide text-gray-500 mb-2">
            Owned Skills ({ownedSkills.length})
          </h2>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {ownedSkills.map((s) => (
              <li key={s.id} className="rounded border border-gray-200 bg-white px-3 py-1.5">
                {s.invoke_pattern}
              </li>
            ))}
          </ul>
        </div>
      )}

      <pre className="rounded-lg border border-gray-200 bg-white p-6 text-sm overflow-x-auto whitespace-pre-wrap">
        {agent.body_md}
      </pre>
    </div>
  );
}
